import React, { useEffect, useRef } from 'react';
import Autocomplete from 'react-google-autocomplete';
// import { usePlacesWidget } from "react-google-autocomplete";
import IconHouse from 'components/Icons/House';
import IconSearch from 'components/Icons/Search';
import IconReset from 'components/Icons/Reset';

type Props = {
  setCenterMap: (centerLatLng: [number, number]) => void;
  resetClicked: number;
  setResetClicked: (reset: number) => void;
};

const YOUR_GOOGLE_MAPS_API_KEY = 'AIzaSyDunvNU6JBRoKP3hNEKzNRdbhux60vq_pA'; // "AIzaSyAeJAuzko3ku-JKNRga9IxmuJ9UrK0hiYk";

const SearchAddress = ({
  setCenterMap,
  resetClicked,
  setResetClicked,
}: Props) => {
  const mainRef = useRef<any>();

  useEffect(() => {
    mainRef.current.value = '';
  }, [resetClicked]);

  return (
    <div className="search-address">
      <h4>Type in your address to search water projects in your area</h4>
      <div className="input-wrapper">
        <IconHouse />
        <div className="input-container">
          <Autocomplete
            apiKey={YOUR_GOOGLE_MAPS_API_KEY}
            ref={mainRef}
            onPlaceSelected={(place, inputRef) => {
              const lat = place.geometry.location.lat();
              const lng = place.geometry.location.lng();
              setCenterMap([lng, lat]);
            }}
            placeholder="Search address..."
            options={{
              types: [],
              componentRestrictions: { country: 'au' },
              // bounds: defaultBounds,
            }}
          />
          <IconSearch />
        </div>
        <button
          type="button"
          className="btn-reset"
          onClick={() => {
            setResetClicked(Date.now());
          }}
        >
          RESET
          <IconReset />
        </button>
      </div>
    </div>
  );
};

export default SearchAddress;
